import { render, staticRenderFns } from "./FramedContent.vue?vue&type=template&id=681907cc&scoped=true&"
import script from "./FramedContent.vue?vue&type=script&lang=js&"
export * from "./FramedContent.vue?vue&type=script&lang=js&"
import style0 from "./FramedContent.vue?vue&type=style&index=0&id=681907cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681907cc",
  null
  
)

export default component.exports